@app.controller 'HeadController', (MetadataService, ProductMetadataService, $state) ->

  @meta = MetadataService
  @productMeta = ProductMetadataService

  @is404 = ->
    $state.current.name == '404'

  this
